import React from 'react';

import OrganizationSettingsForm from '../OrganizationSettingsForm/OrganizationSettingsForm';

export default function OrganizationSettingsManagementRoute() {
  return <OrganizationSettingsForm />;
}
